module.exports = __webpack_public_path__ + "static/media/typebot.53d7de1b.png";